/* eslint-disable import/prefer-default-export */
export const findAnswer = (items, uuid) => {
  if (!items || !Array.isArray(items)) {
    return null;
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const item of items) {
    if (item?.uuid === uuid) {
      return item;
    }
    const subitem = findAnswer(item?.subanswers, uuid);
    if (subitem) {
      return subitem;
    }
  }
  return null;
};

export const findItemByUuid = (items, uuid) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const item of items) {
    if (item.uuid === uuid) {
      return item;
    }
    const subitem = findItemByUuid(item.subanswers, uuid);
    if (subitem) {
      return subitem;
    }
  }
  return null;
};

export const addVictimIdToAnswers = (answers, victimId) => {
  return answers.map((answer) => {
    return {
      ...answer,
      answer: {
        ...answer?.answer,
        victim: victimId
      }
    };
  });
};
